import React from 'react';

const AlertDiamondIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_14135_61946)">
      <path
        d="M8 0C8.63123 0 9.23836 0.242602 9.69629 0.677734L15.2979 6.28809C15.7474 6.73892 16 7.35013 16 7.9873C16 8.62448 15.7474 9.23569 15.2979 9.68652L9.69629 15.2969C9.24618 15.7471 8.63612 16 8 16C7.36388 16 6.75382 15.7471 6.30371 15.2969L0.702148 9.68652C0.252588 9.23569 0 8.62448 0 7.9873C4.26262e-06 7.35013 0.252592 6.73892 0.702148 6.28809L6.30371 0.677734C6.76164 0.242603 7.36877 3.45016e-08 8 0ZM8.02441 9.42285C7.46504 9.42285 7.01078 9.87725 7.01074 10.4375V10.6406C7.01081 11.2008 7.46506 11.6553 8.02441 11.6553C8.58357 11.655 9.03704 11.2007 9.03711 10.6406V10.4375C9.03707 9.87739 8.58359 9.42309 8.02441 9.42285ZM8.02441 4.33887C7.46501 4.33887 7.01074 4.79323 7.01074 5.35352V7.75879C7.01074 8.31907 7.46501 8.77344 8.02441 8.77344C8.58362 8.7732 9.03711 8.31893 9.03711 7.75879V5.35352C9.03711 4.79337 8.58362 4.3391 8.02441 4.33887Z"
        fill="#FF4D4F"/>
    </g>
    <defs>
      <clipPath id="clip0_14135_61946">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export default AlertDiamondIcon;
